import type { LanguageConfig, SupportedLanguage } from "@/types/i18n";
import England from "../assets/icons/england.svg";
import Norway from "../assets/icons/norway.svg";

export const supportedLanguages: SupportedLanguage[] = [
  "en",
  "no",
  // "nn",
  // "sme",
];
export const defaultLanguage: SupportedLanguage = "no";

//used in language select component
export const languageConfigs: Record<SupportedLanguage, LanguageConfig> = {
  en: {
    code: "en",
    name: "English",
    nativeName: "English",
    flag: "🇺🇸",
    flagIcon: England,
  },
  no: {
    code: "no",
    name: "Norwegian",
    nativeName: "Norsk",
    flag: "🇳🇴",
    flagIcon: Norway,
  },
  // nn: {
  //   code: "nn",
  //   name: "Nynorsk",
  //   nativeName: "Norsk nynorsk",
  //   flag: "🇳🇴",
  //   flagIcon: Norway,
  // },
  // sme: {
  //   code: "sme",
  //   name: "Sámi",
  //   nativeName: "Sámi",
  //   flag: "🇸🇯",
  //   flagIcon: Norway,
  // },
};
